/**
 * Checkbox builder — verbatim from v1 (research/03 §11, §15.3; REQ-ELEM-2).
 * Preserves the stray apostrophe after the wrapper's conditionalTemplate and
 * the doubled quote in data-isrequired='…''.
 */
import { appState } from "../state/app-state";
import { getConditionalDisplay, getToolTipHtml , getElementWidthClass, t , dirAttr } from "./base";

export function buildCheckboxInput(element: any): string {
  var checkedValue = element.checkedValue;
  var uncheckedValue = element.uncheckedValue;
  var isrequired = element.isRequired;
  var conditionalDisplay = getConditionalDisplay(element);
  let toolTipHtml = getToolTipHtml(element, "div");

  return (
    "<div class='element checkbox-element" + getElementWidthClass(element) + "' data-element='" +
    element.Identifier +
    "' data-isrequired='" +
    isrequired +
    "' " +
    conditionalDisplay.conditionalTemplate +
    "'><input class='calc-prop checkbox' data-identifier='" +
    element.Identifier +
    "' data-isrequired='" +
    isrequired +
    "'' onchange='ChangeEvent(null)' type='checkbox' value='" +
    checkedValue +
    "' name=\"properties[" +
    element.Name +
    "]\" data-calcname='" +
    element.Name +
    "' data-checkedvalue='" +
    checkedValue +
    "' data-uncheckedvalue='" +
    uncheckedValue +
    "'/><span style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.Name) + ">" +
    t(element.Name) +
    toolTipHtml +
    "</span></div>"
  );
}
